import { render, staticRenderFns } from "./CargoItem.vue?vue&type=template&id=1f80bb26&scoped=true"
import script from "./CargoItem.vue?vue&type=script&lang=js"
export * from "./CargoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80bb26",
  null
  
)

export default component.exports